import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACCOUNTS_URL, LIST_ACCOUNTS_SLICE } from "./account.constant";
import { axiosPrivate } from "../../../config/axios";
import { ErrorPopup } from "../../../utilities/swal";
import { IAccountCreate, IAccountUpdate } from "../../../models/account";
import { IAxiosErrorResponse } from "../../../interface/axiosError";

export const onGetAllAccounts = createAsyncThunk(
  `${LIST_ACCOUNTS_SLICE}/get-list`,
  async (_, thunkAPI: any) => {
    try {
      const res = await axiosPrivate.get(`${ACCOUNTS_URL}`);
      return res?.data;
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const onUpdateAccount = createAsyncThunk(
  `${LIST_ACCOUNTS_SLICE}/update-one`,
  async (payload: { id: string; data: IAccountUpdate }, thunkAPI: any) => {
    try {
      const res = await axiosPrivate.put(
        `${ACCOUNTS_URL}/${payload.id}`,
        payload.data
      );
      return res?.data;
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const onCreateAccount = createAsyncThunk(
  `${LIST_ACCOUNTS_SLICE}/create`,
  async (payload: IAccountCreate, thunkAPI: any) => {
    try {
      const res = await axiosPrivate.post(`${ACCOUNTS_URL}`, payload);
      return res?.data;
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
